import { QuestionnaireResultInterface } from '../interfaces/questionnaire-result.interface';
import { JsonObject, JsonProperty } from 'json2typescript';
import { QuestionInterface } from '../../response/interfaces/question.interface';
import { QuestionModel } from '../../response/models/question.model';

@JsonObject('QuestionnaireResultModel')
export class QuestionnaireResultModel implements QuestionnaireResultInterface {
  @JsonProperty('ClientCode', String, true)
  clientCode: string = undefined;

  @JsonProperty('Answers', [QuestionModel], true)
  answers: QuestionInterface[] = [];

  @JsonProperty('AdvisoryModelCode', String, true)
  advisoryModelCode: string = undefined;

  @JsonProperty('ServiceModelCode', String, true)
  serviceModelCode: string = undefined;

  @JsonProperty('QuestionnaireId', String, true)
  questionnaireId: string = undefined;

  @JsonProperty('ContractCode', String, true)
  contractCode: string = undefined;
}
